import { useState } from "react";
import SuccessPage from "./SuccessPage";


export default function App() {

  const [showEmail, setShowEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;
  
  const handleSubmit = async () => {
    if (!email) return;

    await fetch("http://localhost:5000/api/free-preview", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    setSubmitted(true);
  };

  const handlePayment = async () => {
  const res = await fetch("http://localhost:5000/api/payment/create-order", {
    method: "POST"
  });

  const order = await res.json();

  const options = {
    key: RAZORPAY_KEY_ID,
    amount: order.amount,
    currency: "INR",
    name: "The Boring Wealth",
    description: "Full Blueprint PDF",
    order_id: order.id,
    handler: async function (response) {
      const verifyRes = await fetch(
        "http://localhost:5000/api/payment/verify",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...response,
            email: email
          })
        }
      );

      const data = await verifyRes.json();

      if (data.success) {
        window.location.href = `/success?token=${data.token}&email=${encodeURIComponent(email)}`;
      } else {
        alert("Payment verification failed");
      }
    },
    theme: {
      color: "#d4af37"
    }
  };

  const razorpay = new window.Razorpay(options);
  razorpay.open();
};

const isSuccessPage =
  window.location.pathname === "/success";

if (isSuccessPage) {
  return <SuccessPage />;
}




  return (
    <div className="container">

     {/* HERO */}
    <section className="section text-center">

      <img
        src="/book-cover.jpg"
        alt="The Boring Wealth Book Cover"
        className="img-fluid mb-4 shadow-lg book-cover"
      />

  <h1 className="display-5 fw-bold hero-title mt-3">
    THE BORING WEALTH
  </h1>

  <p className="fs-4 hero-subtitle">
    The Discipline Blueprint to ₹100 Crore
  </p>

  <p className="fst-italic">
    How to Use Gold, Real Estate & Time to Build Massive Wealth
  </p>

      </section>

      {/* ICON STRIP */}
      <section className="section">
        <div className="row text-center">
          <div className="col-md-4 mb-4">
            <div className="icon-box">
              <h4 className="gold-text">Gold</h4>
              <p>Financial insurance & liquidity buffer</p>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="icon-box">
              <h4 className="gold-text">Real Estate</h4>
              <p>Cash-flow focused, survivable leverage</p>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="icon-box">
              <h4 className="gold-text">Time</h4>
              <p>The only multiplier that never breaks</p>
            </div>
          </div>
        </div>
      </section>

      {/* CORE MESSAGE */}
      <section className="section">
        <h3 className="gold-text">
          Stop Chasing Wealth.<br />
          Start Surviving Long Enough to Own It.
        </h3>
        <p>
          People don’t fail because they are careless.
          They fail because they mistake activity for progress.
        </p>
        <p>
          This book is for people who are done restarting.
        </p>
      </section>

      {/* WHAT IT IS / IS NOT */}
      <section className="section">
        <div className="row">
          <div className="col-md-6">
            <h5 className="gold-text">This is NOT</h5>
            <ul>
              <li>Trading</li>
              <li>Get-rich-quick</li>
              <li>Motivation hype</li>
            </ul>
          </div>
          <div className="col-md-6">
            <h5 className="gold-text">This IS</h5>
            <ul>
              <li>A wealth operating system</li>
              <li>Built for Indian realities</li>
              <li>Designed to survive bad years</li>
            </ul>
          </div>
        </div>
      </section>

      {/* LEARNINGS */}
      <section className="section">
        <h4 className="gold-text">What You Will Learn</h4>
        <ul>
          <li>Why boring strategies outperform exciting ones</li>
          <li>Gold as infrastructure, not speculation</li>
          <li>Cash-flow-first real estate rules</li>
          <li>₹1 Cr → ₹100 Cr survivable timeline</li>
        </ul>

        <p className="fw-bold mt-3">
          This book does not promise upside.<br />
          It removes fragility.
        </p>
      </section>

      {/* CORE PHILOSOPHY */}
      <section className="section">
        <blockquote className="fs-4 fst-italic gold-text">
          Wealth is not built by doing more.<br />
          It is built by surviving longer.
        </blockquote>
      </section>

        {/* FREE PREVIEW */}
      <section className="section text-center">
        <h4 className="gold-text">Read a Free Preview</h4>
        <p>Chapter 1 & 2 (Full) · Chapter 3 (Partial)</p>

        {!showEmail && (
          <button
            className="btn btn-outline-gold btn-lg"
            onClick={() => setShowEmail(true)}
          >
            Download Free Preview
          </button>
        )}

        {showEmail && !submitted && (
          <div className="mt-4 mx-auto" style={{ maxWidth: "420px" }}>
            <input
              type="email"
              className="form-control mb-3"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <button
              className="btn btn-gold w-100"
              onClick={handleSubmit}
            >
              Send Free Preview
            </button>

            <p className="small text-muted mt-2">
              No spam. No newsletters. Just the preview.
            </p>
          </div>
        )}

        {submitted && (
          <p className="gold-text mt-4">
            ✔ Check your email for the preview link
          </p>
        )}
      </section>

      {/* PRICING */}
      <section className="section text-center">
        <h4 className="gold-text">Pricing</h4>
        <p className="display-6 fw-bold">₹1,499</p>
        <p>
          You only need to get rich once.<br />
          But you must survive every year.
        </p>
        <button
          className="btn btn-gold btn-lg px-5"
          data-bs-toggle="modal"
          data-bs-target="#emailModal"
        >
          Download The Full Blueprint
        </button>

      </section>

      {/* AUTHOR */}
      <section className="section">
        <h5 className="gold-text">Rajkumar Sharma</h5>
        <p>
          Writes about boring wealth, unbreakable financial structures,
          and long-term asset-based portfolios in India.
        </p>
      </section>

      {/* FOOTER */}
      <footer className="text-center py-4">
        <p>
          Educational purposes only. No financial or investment advice.
        </p>
        <a href="/terms">Terms</a> ·
        <a href="/privacy">Privacy</a> ·
        <a href="/refund">Refund</a> ·
        <a href="/shipping">Delivery</a> ·
        <a href="/contact">Contact</a>
      </footer>
    
    {/* EMAIL POPUP MODAL */}
      <div
        className="modal fade"
        id="emailModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content bg-dark text-light border border-warning">

            <div className="modal-header border-warning">
              <h5 className="modal-title gold-text">
                Enter your email
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <p className="small">
                Your email is used to deliver your personal PDF copy and receipt.
              </p>

              <input
                type="email"
                className="form-control"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setEmailError("");
                }}
              />

              {emailError && (
                <div className="text-danger small mt-2">
                  {emailError}
                </div>
              )}
            </div>

            <div className="modal-footer border-warning">
              <button
                className="btn btn-outline-gold"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>

              <button
                className="btn btn-gold"
                onClick={() => {
                  if (!email || !email.includes("@")) {
                    setEmailError("Please enter a valid email");
                    return;
                  }

                  // Close modal
                  const modal = window.bootstrap.Modal.getInstance(
                    document.getElementById("emailModal")
                  );
                  modal.hide();

                  // Start payment
                  handlePayment();
                }}
              >
                Continue to Payment
              </button>
            </div>

          </div>
        </div>
      </div>

    </div>
  );
}
